import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08c0fa53"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "aria-label", "title"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["disabled", "aria-label"]

import {computed,ref,watch,onBeforeUnmount} from 'vue'
import store from '@/store'
import api from '@/api/sys'
import platformLogo from '@/assets/images/logo-dark.png'
import {storefrontHref,storefrontLogo} from '@/utils/storefrontShortcut'

export default /*#__PURE__*/_defineComponent({
  __name: 'StorefrontShortcut',
  setup(__props) {

const summary=ref<any>(null),loading=ref(false),imageFailed=ref(false)
const orgId=computed(()=>Number(store.getters.userInfo?.orgId)),platform=computed(()=>orgId.value===1000)
const identity=computed(()=>[store.getters.token,store.getters.userInfo?.id,orgId.value].join(':'))
const href=computed(()=>storefrontHref(String(process.env.VUE_APP_CLIENT_URL || ''),orgId.value,summary.value))
const logo=computed(()=>platform.value?platformLogo:storefrontLogo(summary.value?.logoUrl,String(store.getters.settings?.imgurl?.value || '')))
const label=computed(()=>platform.value?'打开蓝迪云首页':href.value?'打开本店客户端 · '+String(summary.value?.orgShortName || summary.value?.orgName || ''):loading.value?'正在读取本店入口':'本店入口未就绪，点击重试')
let generation=0
async function load(){
  const run=++generation,who=identity.value,id=orgId.value
  summary.value=null;imageFailed.value=false
  if(platform.value || !store.getters.token || !Number.isSafeInteger(id) || id<=1000){loading.value=false;return}
  loading.value=true
  try{const response=await api.getOrgInfo(id);if(run===generation && who===identity.value && Number(response.data?.id)===id)summary.value=response.data}
  catch{/* 不猜测店铺，不退回平台或其他分店。 */}
  finally{if(run===generation)loading.value=false}
}
watch(identity,load,{immediate:true})
onBeforeUnmount(()=>{generation++})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_tooltip, { title: label.value }, {
    default: _withCtx(() => [
      (href.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "storefront-shortcut",
            href: href.value,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": label.value,
            title: label.value
          }, [
            (logo.value && !imageFailed.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: logo.value,
                  alt: platform.value?'蓝迪云黑白LOGO':'当前店铺LOGO',
                  onError: _cache[0] || (_cache[0] = ($event: any) => (imageFailed.value=true))
                }, null, 40, _hoisted_2))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(String(summary.value?.orgShortName || summary.value?.orgName || '店').slice(0,1)), 1))
          ], 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "storefront-shortcut storefront-retry",
            type: "button",
            disabled: loading.value,
            "aria-label": label.value,
            onClick: load
          }, "店", 8, _hoisted_4))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})